class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      //this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  /*
  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }
  */

  onChange(event) {
    if(event.target.className == 'giftwrap-prop'){
      this.addItemGiftwrap(event.target.dataset.index, event.target.checked, event);
    }else{
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }
  }

  addItemGiftwrap(line, value, event) {
    var wrapit = 'No'
    if(value == true){
      wrapit = 'Yes'
    }
    const body = JSON.stringify({
      line,
      'properties': { '_gift_wrap': wrapit },
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);
    [...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        let currentTarget = event.target.name;
        let currentLabel = document.querySelector('label[for="'+ currentTarget +'"]');
        let currentCTA = currentLabel.innerText;
        let addCTA = currentLabel.dataset.add;
        let removeCTA = currentLabel.dataset.remove;

        if(currentCTA == addCTA){
          currentLabel.innerText = removeCTA;
        }else{
          currentLabel.innerText = addCTA;
        }
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
    });

  }



  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch(e => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items'});

        if(parsedState.item_count === 0) {
          document.querySelector('.drawer__inner').classList.remove('active');
        } else {
          if(parsedState.sections['cart-drawer'] && parsedState.sections['cart-drawer'].includes('data-sale-product-id')) {
            let regex = new RegExp('data-sale-product-id="(.*)"');
            let results = regex.exec(parsedState.sections['cart-drawer']);
            if(results != null && results.length > 1) {
              setupCartOversell(results[1], true);
            } else {
              setupCartOversell(parsedState.items[0].product_id);
            }
          } else {
            setupCartOversell(parsedState.items[0].product_id);
          }
        }
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
      constructor() {
        super();

      this.addEventListener('change', debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, ON_CHANGE_DEBOUNCE_TIMER))
      }
  });
};

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      if(parsedState.product_id) {
        if(parsedState.sections['cart-drawer'] && parsedState.sections['cart-drawer'].includes('data-sale-product-id')) {
          let regex = new RegExp('data-sale-product-id="(.*)"');
          let results = regex.exec(parsedState.sections['cart-drawer']);
          if(results != null && results.length > 1) {
            setupCartOversell(results[1], true);
            return;
          }
        }
        setupCartOversell(parsedState.product_id);
      }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

function setupCartOversell(id, isSale = false) {
  document.querySelector('.complete-look').addEventListener('click', function(){
    document.querySelector('.drawer__inner').classList.toggle('active');
  });

  Tagalys.UIWidgets.Recommendations.init('[data-widget="recommendations-cart"]', {
    recommendationId: isSale ? "d9bfce560dbd50e0b364" : "5fbdfb8c860eecfd1e73",
    productId: id,
    limit: 4,
    templates: {
      leftArrow: {
        render: function (html, args) {
          var props = args.props;
          return html`
            <button class=${`carousel-btn ${props.disabled ? "btn-disabled" : ""}`} onClick=${props.disabled ? undefined : props.goLeft}>
              <svg aria-hidden="true" focusable="false" class="icon icon-caret left" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1 9L5 5L1 1" stroke="currentColor"></path>
              </svg>
            </button>
          `;
        },
      },
      rightArrow: {
        render: function (html, args) {
          var props = args.props;
          return html`
              <button class=${`carousel-btn ${props.disabled ? "btn-disabled" : ""}`} onClick=${props.disabled ? undefined : props.goRight}>
                <svg aria-hidden="true" focusable="false" class="icon icon-caret right" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M1 9L5 5L1 1" stroke="currentColor"></path>
                </svg>
              </button>
            `;
        },
      },
      product: {
        render: function (html, args) {
          let props = args.props;
          let product = props.product;
          let helpers = props.helpers;
          var price = helpers.getPrice(product);
          var compareAtPrice = helpers.getCompareAtPrice(product);
          let product_parts = product.title.split(" - ");
          let product_title = product_parts[0];
          let product_subtitle = product_parts[1];
          let product_color = product_parts[2];
          let product_color_lower;
          if (product_color === undefined) {
            product_color = "invisible";
            product_color_lower = "invisible";
          } else {
            product_color_lower = product_color.toLowerCase();
          }

          if (!product.available) {
            return;
          }

          var displayPrice = product.compare_at_price === null
              ? product.price_max
              : product.compare_at_price;
          var product_price = product.price;

          var moneyFormat = window.tagalysConf.moneyFormat; // Dönen değer: 10.000 Ft
          var moneyFormatC = window.tagalysConf.moneyFormatTrailingZeros;
          var hasDesimal = false;
          if (moneyFormat != moneyFormatC) {
            hasDesimal = true;
          }
                    
          var currencySymbol = window.tagalysConf.currencySymbol; // Shopify'den alınan para birimi sembolü

          function formatMoney(value) {
            if(value === null) {
              return '';
            }
            if (currencySymbol == "$" || currencySymbol == "¥" || currencySymbol == "£" || currencySymbol == 'د.إ' || currencySymbol == 'Dhs.'){
              return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else {
              return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            }
          }

          var formattedPrice = formatMoney(displayPrice);
          var formattedPrice2 = formatMoney(product_price);

          var moneySymbolPosition = moneyFormat.indexOf(currencySymbol); 
          var spacePosition = moneyFormat.indexOf(' '); 
          var space = '';
          if (spacePosition > 0) {
            space = " ";
          }
          
          if (hasDesimal) {
            if (currencySymbol == "$" || currencySymbol == "¥" || currencySymbol == "£" || currencySymbol == 'د.إ' || currencySymbol == 'Dhs.'){
              formattedPrice = formattedPrice+".00";
              formattedPrice2 = formattedPrice2+".00";
            } else {
              formattedPrice = formattedPrice+",00";
              formattedPrice2 = formattedPrice2+",00";
            }
          }        

          if(currencySymbol == 'د.إ' || currencySymbol == 'Dhs.') {
              displayPrice = 'AED' + space + formattedPrice;
              product_price = 'AED' + space + formattedPrice2;
          } else if (moneySymbolPosition == 0) {
              displayPrice = currencySymbol + space + formattedPrice;
              product_price = currencySymbol + space + formattedPrice2;
          } else {
              displayPrice = formattedPrice + space + currencySymbol;
              product_price = formattedPrice2 + space + currencySymbol;
          }

          var discount_percentage = '';
          if (product.metafields.custom) {
            if (product.metafields.custom.discount_percentage){
              if (product.metafields.custom.discount_percentage.value){
                discount_percentage = product.metafields.custom.discount_percentage.value;
              }
            }
          }
          var image = product.__tagalys_fields.image_url;
          image = image.replace("400x400", "480x480");

          var variants = product.variants;
          // var variantsForm = `<div class="variantForm">`;
          // var variants_available = true;    
          // for (var i = 0; i < variants.length; i++) {
          //   if (!variants[i].available) {
          //     variants_available = false;
          //   }

          //   variantsForm += `<button type="button" ${!variants[i].available ? 'class="disabled" disabled' : ''} data-id="${variants[i].id}">${variants[i].title}</button>`;
          // }
          // variantsForm += `</div>`;

          // if (!variants_available) {
          //   return;
          // }

          var variantsForm = html`
              <div class="variantForm">
                ${variants.map(function(variant) {
                  if(variant.available) {
                    return html`
                      <button type="button" data-id="${variant.id}">${variant.title}</button>
                    `;
                  } else {
                    return html`
                      <button type="button" class="disabled" disabled data-id="${variant.id}">${variant.title}</button>
                    `;
                  }
                })}
              </div> 
            `;
          
          return html`
              <div class="product exclude-tagalys-css-reset card card--standard" style="position: relative;">
                  <div
                          class="product-link"
                  >
              <span class="product-image-container">
              <a href=${product.__tagalys_fields.link}>
                <img
                        class="product-image"
                        src="${image}"
                        data-src=${image}
                        alt=${product.title}
                        loading="lazy"
                />
              </a>
              </span>
                      <div class="card__content">
                          <div class="card__badge top left" style="position: absolute; padding: 1.6rem; left: 0; top: 0; color: red;"> 
                            <span id="" class="badge badge--bottom-left color-sale" style="color: red;"> ${discount_percentage} </span> 
                          </div>
                          <div class="card__information">
                              <div class="card_titles">
                                  <h3 class="card__heading">${product_title}</h3>
                                  <span class="card__subtitle">${product_subtitle}</span>
                              </div>
                              <div class="card-information">
                                  <div
                                          class=${`product-prices${
                                                  helpers.isProductOnSale(
                                                          product.compare_at_price,
                                                          product.price_max
                                                  )
                                                          ? " discounted"
                                                          : " full-price"
                                          }`}
                                  >
                                      ${helpers.isProductOnSale(
                                              product.compare_at_price,
                                              product.price_max
                                      )
                                              ? html`
                                                  <span class="product-price-discounted"
                                                  >${product_price}</span
                                                  >
                                              `
                                              : null}
                                      <div class="product-price-regular">
                                          ${displayPrice}
                                      </div>
                                  </div>
                              </div>
                              ${variantsForm}
                          </div>
                          <a class="upsell-add-to-cart" href="javascript: void(0);">Select Size</a> 
                      </div>
                  </div>
              </div>
          `;
        },
      },
    },
    callbacks: {
      afterInitialRender: function (helpers) {
        if (document.querySelector('.tagalys').hasChildNodes()) {
          document.querySelector('.tagalys-container').classList.remove("no-products");
        } else {
          document.querySelector('.tagalys-container').classList.add("no-products");
        }
      }
    }
  });

}